<label [ngClass]="boxClasses" (click)="onToggle()">

  <!-- ── 1. Carré checkbox — toujours en premier ──────────────── -->
  <span class="checkbox-box__control">
    <!-- Checkmark SVG — visible quand coché -->
    @if (checked()) {
      <svg class="checkbox-box__check" viewBox="0 0 12 10" fill="none">
        <path d="M1 5L4.5 8.5L11 1.5"
              stroke="currentColor"
              stroke-width="1.75"
              stroke-linecap="round"
              stroke-linejoin="round"/>
      </svg>
    }
  </span>

  <!-- ── 2. Icône gauche ───────────────────────────────────────── -->
  @if (iconPosition === 'left' && activeIconTpl) {
    <span class="checkbox-box__icon">
      <ng-container *ngTemplateOutlet="activeIconTpl"></ng-container>
    </span>
  }

  <!-- ── 3. Label ──────────────────────────────────────────────── -->
  @if (label) {
    <span class="checkbox-box__label">{{ label }}</span>
  }

  <!-- ── 4. Icône droite ───────────────────────────────────────── -->
  @if (iconPosition === 'right' && activeIconTpl) {
    <span class="checkbox-box__icon">
      <ng-container *ngTemplateOutlet="activeIconTpl"></ng-container>
    </span>
  }

</label>

<!-- Message d'erreur -->
@if (showError) {
  <span class="checkbox-error" role="alert">
    {{ errorMessage }}
  </span>
}
